var HashDialogView = require('hashdialogview');
var FileView = require('fileview');

var FilesDialogView = HashDialogView.extend({
    modelViews: {},
    el: '#filesOverlayContents',
    wrapper: $('#filesContainer'),
    list: $('#filesList'),
    urlRoot: 'files',
    collectionKey: 'files',
    modelView: FileView,
    initialize: function (options) {
        HashDialogView.prototype.initialize.call(this, options);
        
        this.collection = this.model[this.collectionKey];
        this.router.route('?/' + this.urlRoot, 'show', _.bind(this.show, this));
        this.router.route('?/' + this.urlRoot + '=:page', 'show', _.bind(this.show, this));
        this.collection.bind('add', this.addModel, this);
        this.collection.bind('remove', this.removeModel, this);
    },
    show: function (page) {
        this.$('.loadingProgress').hide();
        this.$('.loadingError').hide();
        this.fetch(page);
        HashDialogView.prototype.show.call(this);
    },
    renderPage: function (page, label, thisPage, loadingPage) {
        var li = $('<li>');
        if (page) {
            li.addClass('enabled');
            if (page === thisPage) {
                li.addClass('active');
            }
            if (page === loadingPage) {
                li.addClass('loading');
            }
        }
        var link = $('<a>').text(label).attr('href', '/?/' + this.urlRoot + '=' + (page || thisPage));
        li.append(link);
        return li;
    },
    pageRange: function (pages, thisPage) {
        var range;
        if (pages < 13) {
            range = _.range(1, pages+1);
        } else {
            var head = [1,2,3];
            var gap = [null];
            var tail = _.range(pages-2, pages+1);
            if ((thisPage + 1) > (pages - 5)) {
                range = head
                    .concat(gap)
                    .concat(_.range(Math.min(thisPage-1, pages-2), pages+1));
            } else if ((thisPage - 1) < 5) {
                range = _.range(1, Math.max(thisPage+2, 4))
                    .concat(gap)
                    .concat(tail);
            } else {
                range = head
                    .concat(gap)
                    .concat(_.range(thisPage-1, thisPage+2))
                    .concat(gap)
                    .concat(tail);
            }
        }
        return range;
    },
    renderPagination: function (pages, loadingPage) {
        var pagination = this.$('ul.pagination');
        pagination.empty();
        if (pages > 1) {
            var thisPage = this.collection.page;
            var nextPrevPage = loadingPage || thisPage;
            var prev = this.renderPage((nextPrevPage>1) ? nextPrevPage-1 : 0, '«', nextPrevPage);
            pagination.append(prev);

            var range = this.pageRange(pages, thisPage);
            _.each(range, function (page, i) {
                var li = this.renderPage(page, page || '…', thisPage, loadingPage);
                if (i < range.length-1 && !range[i+1]) {
                    li.addClass('right');
                } else if (i && !range[i-1]) {
                    li.addClass('left');
                }
                pagination.append(li);
            }, this);

            var next = this.renderPage((nextPrevPage<pages) ? nextPrevPage+1 : 0, '»', nextPrevPage);
            pagination.append(next);
        }
        pagination.each(function () {
            $(this).find('.enabled').first().addClass('left');
            $(this).find('.enabled').last().addClass('right');
        });
    },
    afterHide: function () {
        if (this.fetchPromise) {
            this.fetchPromise.reject();
            this.fetchPromise = null;
        }
    },
    fetch: function (page) {
        this.$el.addClass('loading');
        var pages = this.collection.getPages();
        this.renderPagination(pages, (page-0||1));
        if (this.fetchPromise) {
            this.fetchPromise.reject();
        }
        this.fetchPromise = this.collection.fetch(page);
        this.fetchPromise.done(_.bind(function () {
            pages = this.collection.getPages();
            if (!page && pages > 1) {
                this.router.navigate('?/' + this.urlRoot + '=1', {replace: true});
            }
            this.renderPagination(pages);
        }, this)).progress(_.bind(function (response, failInfo) {
            var loadingProgress = this.$('.loadingProgress');
            loadingProgress.show();
            var failInfoSpan = loadingProgress.find('.failInfo');
            if (failInfo.failCount > 1) {
                failInfoSpan.text(' (' + failInfo.failCount + ' attempts)');
            }
        }, this)).fail(_.bind(function (response, failInfo) {
            this.$('.loadingError').show();
        }, this)).always(_.bind(function () {
            this.fetchPromise = null;
            this.$('.loadingProgress').hide();
            this.$el.removeClass('loading');
        }, this));
    },
    renderView: function (view) {
        return view.render();
    },
    addModel: function (model) {
        var view = new this.modelView({model: model});
        // Insert at correct position
        var existing = this.list.children();
        var index = this.collection.indexOf(model);
        var el = this.renderView(view).el;
        if (index == existing.length) {
            this.list.append(el);
        } else {
            existing.eq(index).before(el);
        }
        this.modelViews[model.id] = view;
    },
    removeModel: function (model) {
        var view = this.modelViews[model.id];
        view.remove();
        delete this.modelViews[model.id];
    }
});


module.exports = FilesDialogView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/filesdialogview.js
// module id = Nbol
// module chunks = 1